// extracted by mini-css-extract-plugin
export default {"c-input-search":"elastic-search-box_component_c-input-search__vPDsS"};